import { Link } from 'react-router-dom';
import { Divider } from '@chakra-ui/layout';
import './FooterStyles.css';
import { FormattedMessage } from 'react-intl';
import { getAppVersion } from '../../../utils/version';

export const Footer = () => {
  const date = new Date();
  const version = getAppVersion();
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="copyright-area">
          <span>
            &copy;
            {date.getFullYear()}
          </span>
          <span>
            ipscore.app - <FormattedMessage id="AllRightsReserved" />
          </span>
          <span className="footer-version">{version}</span>
        </div>
        <div className="nav-area">
          <Link to="/terms-and-conditions">
            <FormattedMessage id="TermsAndConditions" />
          </Link>
          <Divider mx={4} orientation="vertical" />
          <Link to="/privacy-policy">
            <FormattedMessage id="PrivacyPolicy" />
          </Link>
        </div>
      </div>
    </footer>
  );
};
